/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const signImageUploadDataMimeTypeSchema = z.enum([
	'image/jpeg',
	'image/png',
	'image/webp',
	'image/svg+xml',
	'image/avif',
])

export type SignImageUploadDataMimeTypeSchema = z.infer<typeof signImageUploadDataMimeTypeSchema>
